import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import customFetchBase from '../expiredToken/expiredToken';
import { ISequenceResponse } from '../../types/sequences/sequencesInterface';
import {
  ILightShowPayload,
  ISceneLightShow
} from '../../types/Scenes/scenesTypes';
import { SceneType } from '../../types/sceneType';

const customFetch = customFetchBase(config.baseUrlDealers);

export const apiSequence = createApi({
  reducerPath: 'apiLocations',
  baseQuery: customFetch,
  endpoints: (builder) => ({
    getSequenceListByLocation: builder.mutation<ISequenceResponse, number>({
      query: (locationId) => ({
        url: `/api/Sequence`,
        method: 'GET',
        params: {
          locationId
        }
      })
    }),
    executeLightShow: builder.mutation<'', number>({
      query: (sequenceId) => ({
        url: `api/Commands/Sequence/Execute`,
        method: 'POST',
        body: { sequenceId }
      })
    }),
    deleteLightShow: builder.mutation<'', number>({
      query: (sequenceId) => ({
        url: `api/Sequence/${sequenceId}`,
        method: 'DELETE'
      })
    }),
    saveLightShow: builder.mutation<
      '',
      { type: string; payload: ILightShowPayload }
    >({
      query: ({ type, payload }) => ({
        url: `api/Sequence/${type}`,
        method: 'POST',
        body: payload
      })
    }),
    resaveSequences: builder.mutation<'', number>({
      query: (locationId) => ({
        url: `api/Sequence/Resave/Location/${locationId}`,
        method: 'POST'
      })
    }),
    getSceneLightShowListByLocation: builder.mutation<
      ISceneLightShow[],
      { locationId: number; sceneType: SceneType }
    >({
      query: (body) => ({
        url: `/api/Scene/UserScenesByLocation?locationId=${body.locationId}&sceneType=${body.sceneType}`
      })
    }),
    resaveSequence: builder.mutation<'', number>({
      query: (sequenceId) => ({
        url: `api/Commands/ResaveSequence`,
        method: 'POST',
        body: { sequenceId }
      })
    })
  })
});

export const {
  useGetSequenceListByLocationMutation,
  useExecuteLightShowMutation,
  useDeleteLightShowMutation,
  useSaveLightShowMutation,
  useResaveSequencesMutation,
  useGetSceneLightShowListByLocationMutation,
  useResaveSequenceMutation
} = apiSequence;
